import { useStartoverButton } from './useStartOverButton';
import playerService from '../../../helpers/bitmovinPlayer';
import { UIVariant } from 'bitmovin-player-ui';
import { createAdsUI } from '../utils/AdsUiUtils';
import { createPlayerUI } from '../utils/PlayerUiUtils';
import { useMemo } from 'react';
import { UseCustomUiParams } from '../types/iPlayerUi';

export const useCustomUi = ({
    playerType,
    LinearAsset,
    withSimpleUIInMinimizedMode,
    renderCustomButton,
    renderSkipIntro,
    renderSkipOutro,
    renderWatchCredit,
    // TODO: not needed?
    toggleMute,
    startOverPlayback,
}: UseCustomUiParams): any => {
    const startOverBtn = useStartoverButton(LinearAsset, startOverPlayback);

    const UIComponents: {
        renderCustomButton?: () => React.ReactNode;
        renderSkipIntro?: () => React.ReactNode;
        renderSkipOutro?: () => React.ReactNode;
        renderWatchCredit?: () => React.ReactNode;
        renderStartover?: () => any;
        playerType?: string;
        // TODO: is this used?
        toggleMute?: () => void;
    } = {};

    if (renderCustomButton) UIComponents.renderCustomButton = () => renderCustomButton(playerService.player);
    if (renderSkipIntro) UIComponents.renderSkipIntro = () => renderSkipIntro(playerService.player);
    if (renderSkipOutro) UIComponents.renderSkipOutro = () => renderSkipOutro(playerService.player);
    if (renderWatchCredit) UIComponents.renderWatchCredit = () => renderWatchCredit(playerService.player);
    if (startOverBtn) UIComponents.renderStartover = () => startOverBtn;
    if (toggleMute) UIComponents.toggleMute = toggleMute;
    UIComponents.playerType = playerType;

    const uiVariantsFactory = (): UIVariant[] => [
        { ui: createAdsUI(), condition: (context) => context.isAd },
        {
            ui: createPlayerUI(UIComponents, withSimpleUIInMinimizedMode, true),
            condition: (context) => context.isFullscreen,
        },
        {
            ui: createPlayerUI(UIComponents, withSimpleUIInMinimizedMode),
            condition: (context) => !context.isFullscreen,
        },
        {
            // UI variant with custom seekbar
            ui: createPlayerUI(UIComponents, withSimpleUIInMinimizedMode, null, true),
        },
    ];

    const customUi = useMemo(() => ({ variantsFactory: uiVariantsFactory }), []);
    return { customUi };
};
